import Hls from "hls.js";
import type { HlsConfig } from "hls.js";
import { HlsJsP2PEngine } from "p2p-media-loader-hlsjs";

const HlsWithP2P = HlsJsP2PEngine.injectMixin(Hls);

const env = typeof process !== "undefined" ? process.env : undefined;
const configuredTrackers = env?.EXPO_PUBLIC_P2P_TRACKERS
  ?.split(",")
  .map((value) => value.trim())
  .filter(Boolean);

export const isP2PHlsEnabled = (videoEnabled: boolean) =>
  videoEnabled &&
  env?.EXPO_PUBLIC_P2P_ENABLED !== "false" &&
  typeof window !== "undefined" &&
  window.isSecureContext &&
  typeof window.RTCPeerConnection !== "undefined" &&
  typeof window.WebSocket !== "undefined";

export const createHlsPlayer = (
  config: Partial<HlsConfig>,
  swarmId: string,
  videoEnabled: boolean,
): Hls => {
  if (!isP2PHlsEnabled(videoEnabled)) {
    return new Hls(config);
  }

  return new HlsWithP2P({
    ...config,
    p2p: {
      core: {
        swarmId,
        // Never delay startup for peer discovery; HTTP remains the safety net.
        httpDownloadInitialTimeoutMs: 0,
        p2pNotReceivingBytesTimeoutMs: 1500,
        simultaneousHttpDownloads: 2,
        simultaneousP2PDownloads: 2,
        p2pMaxPeers: 8,
        webRtcOffersCount: 3,
        ...(configuredTrackers?.length
          ? { announceTrackers: configuredTrackers }
          : {}),
      },
    },
  });
};
